import { Route, Routes } from "react-router-dom";
import ProtectedLayout from "../layouts/ProtectedLayout";
import Landing from "../pages/Landing";
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import Dashboard from "../pages/Dashboard";
import Profile from "../pages/Profile";
import AdminUsers from "../pages/AdminUsers";
import AdminRoles from "../pages/AdminRoles";
import AdminObjects from "../pages/AdminObjects";
import AdminWorkflows from "../pages/AdminWorkflows";
import AdminApiKeys from "../pages/AdminApiKeys";
import AdminApiDocs from "../pages/AdminApiDocs";
import AdminWebhooks from "../pages/AdminWebhooks";
import AdminAudit from "../pages/AdminAudit";
import WorkflowBuilder from "../pages/WorkflowBuilder";
import ObjectRecords from "../pages/ObjectRecords";
import ObjectBoard from "../pages/ObjectBoard";
import PipelineBuilder from "../pages/PipelineBuilder";
import NotFound from "../pages/NotFound";

export default function AppRoutes() {
    return (
        <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />

            {/* App shell — requires a valid session */}
            <Route element={<ProtectedLayout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/roles" element={<AdminRoles />} />
                <Route path="/admin/objects" element={<AdminObjects />} />
                <Route path="/admin/workflows" element={<AdminWorkflows />} />
                <Route
                    path="/admin/workflows/new"
                    element={<WorkflowBuilder />}
                />
                <Route
                    path="/admin/workflows/:id"
                    element={<WorkflowBuilder />}
                />
                <Route path="/admin/api-keys" element={<AdminApiKeys />} />
                <Route path="/admin/api-docs" element={<AdminApiDocs />} />
                <Route path="/admin/webhooks" element={<AdminWebhooks />} />
                <Route path="/admin/audit" element={<AdminAudit />} />
                <Route path="/o/:slug" element={<ObjectRecords />} />
                <Route path="/o/:slug/board" element={<ObjectBoard />} />
                <Route path="/o/:slug/pipeline" element={<PipelineBuilder />} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}
